<input
  (accept)="onAccept()"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [attr.placeholder]="props.placeholder || ''"
  [attr.data-id]="field.dataId"
  [imask]="imaskNumeric"
  [class.disabled]="props.disabled"
  [unmask]="true"
  autocomplete="off"
  class="numeric-input"
/>
